import { render, staticRenderFns } from "./WorkspaceNodeActionMenu.vue?vue&type=template&id=17175c6e&scoped=true"
import script from "./WorkspaceNodeActionMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceNodeActionMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceNodeActionMenu.vue?vue&type=style&index=0&id=17175c6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17175c6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17175c6e')) {
      api.createRecord('17175c6e', component.options)
    } else {
      api.reload('17175c6e', component.options)
    }
    module.hot.accept("./WorkspaceNodeActionMenu.vue?vue&type=template&id=17175c6e&scoped=true", function () {
      api.rerender('17175c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceNodeActionMenu.vue"
export default component.exports